import $axios from '../services/api.js'

const state = () => ({
    quranSurahDetail: [],
    page: 0,
    prev_page_url : null,
    next_page_url : null
})

const mutations = {
    ASSIGN_DATA_SURAH_DETAIL(state, payload) {
        state.quranSurahDetail = payload
    },
    SET_PAGE(state, payload) {
        state.page = payload
    },
    SET_PREV_PAGE(state, payload) {
        state.prev_page_url = payload
    },
    SET_NEXT_PAGE(state, payload) {
        state.next_page_url = payload
    },
}

const actions = {
    getQuranSurahDetail({ commit }, payload) {
        let surah_id = ""
        let page = {}
        if(Array.isArray(payload)) {
            surah_id = payload[0]
            page = payload[1] != 'undefined' ? { page : payload[1] } : {}
        } else {
            surah_id = payload
        }

        return new Promise((resolve) => {
            $axios.get(`api/quran/${surah_id}`, {
                params: page
            })
                .then((response) => {
                    commit('ASSIGN_DATA_SURAH_DETAIL', response.data.data.data)

                    commit('SET_PAGE', response.data.data.current_page)
                    commit('SET_NEXT_PAGE', response.data.data.next_page_url)
                    commit('SET_PREV_PAGE', response.data.data.prev_page_url)

                    resolve(response.data)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}